import { Controller } from "@hotwired/stimulus"

// Shows a confirmation modal before performing a DELETE request.
// Usage: wrap content in <div data-controller="delete-confirm">;
// include modal with data-delete-confirm-target="overlay";
// links use data-action="click->delete-confirm#open" (href is used as delete URL).
// Modal confirm button: data-action="click->delete-confirm#confirm".
export default class extends Controller {
  static targets = ["overlay"]

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    if (!this.hasOverlayTarget) return
    this.deleteUrl = event.currentTarget.href || event.currentTarget.dataset.deleteUrl
    if (!this.deleteUrl) return
    this.overlayTarget.classList.remove("hidden")
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("hidden")
  }

  overlayClick(event) {
    if (event.target === this.overlayTarget) this.close(event)
  }

  stopPropagation(event) {
    if (event) event.stopPropagation()
  }

  confirm(event) {
    if (event) event.preventDefault()
    if (!this.deleteUrl) return
    const form = document.createElement("form")
    form.method = "post"
    form.action = this.deleteUrl
    form.setAttribute("data-turbo", "true")
    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = "delete"
    form.appendChild(methodInput)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
    if (csrfToken) {
      const csrfInput = document.createElement("input")
      csrfInput.type = "hidden"
      csrfInput.name = "authenticity_token"
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }
    document.body.appendChild(form)
    form.requestSubmit()
    document.body.removeChild(form)
    this.overlayTarget.classList.add("hidden")
  }
}
